// 支持的语言列表
export const supportedLanguages = [
  { code: 'zh-CN', name: '中文', flag: '🇨🇳' },
  { code: 'en-US', name: 'English', flag: '🇺🇸' },
  { code: 'ja-JP', name: '日本語', flag: '🇯🇵' },
  { code: 'ko-KR', name: '한국어', flag: '🇰🇷' },
  { code: 'ms-MY', name: 'Bahasa Melayu', flag: '🇲🇾' }
];

// 常用短语配置
export const phrases = [
  {
    category: "点餐相关",
    translations: {
      "en-US": "Ordering",
      "ja-JP": "注文関連",
      "ko-KR": "주문 관련",
      "ms-MY": "Berkaitan Pesanan"
    },
    items: [
      {
        text: "我要一份米饭",
        translations: {
          "en-US": "I would like a bowl of rice",
          "ja-JP": "ご飯を一杯お願いします",
          "ko-KR": "밥 한 그릇 주세요",
          "ms-MY": "Saya mahu semangkuk nasi"
        }
      },
      {
        text: "这个菜不要放辣",
        translations: {
          "en-US": "Please make this dish non-spicy",
          "ja-JP": "この料理は辛くしないでください",
          "ko-KR": "이 음식은 맵지 않게 해주세요",
          "ms-MY": "Tolong masak hidangan ini tidak pedas"
        }
      },
      {
        text: "我需要一双筷子",
        translations: {
          "en-US": "I need a pair of chopsticks",
          "ja-JP": "お箸を一膳ください",
          "ko-KR": "젓가락 한 벌 필요합니다",
          "ms-MY": "Saya perlukan sepasang penyepit"
        }
      },
      {
        text: "这个是主食",
        translations: {
          "en-US": "This is the main course",
          "ja-JP": "これが主食です",
          "ko-KR": "이것이 주식입니다",
          "ms-MY": "Ini adalah hidangan utama"
        }
      }
    ]
  },
  {
    category: "服务相关",
    translations: {
      "en-US": "Service",
      "ja-JP": "サービス関連",
      "ko-KR": "서비스 관련",
      "ms-MY": "Berkaitan Perkhidmatan"
    },
    items: [
      {
        text: "需要加水",
        translations: {
          "en-US": "Need water refill",
          "ja-JP": "お水を追加してください",
          "ko-KR": "물 리필이 필요합니다",
          "ms-MY": "Perlukan tambahan air"
        }
      },
      {
        text: "餐具需要更换",
        translations: {
          "en-US": "Need new utensils",
          "ja-JP": "食器を交換してください",
          "ko-KR": "수저를 교체해 주세요",
          "ms-MY": "Perlukan peralatan makan baharu"
        }
      },
      {
        text: "准备好结账了",
        translations: {
          "en-US": "Ready for the bill",
          "ja-JP": "お会計をお願いします",
          "ko-KR": "계산할 준비가 되었습니다",
          "ms-MY": "Sedia untuk membayar bil"
        }
      },
      {
        text: "食物需要加热",
        translations: {
          "en-US": "Food needs reheating",
          "ja-JP": "料理を温めなおしてください",
          "ko-KR": "음식을 데워주세요",
          "ms-MY": "Makanan perlu dipanaskan"
        }
      }
    ]
  },
  {
    category: "特殊需求",
    translations: {
      "en-US": "Special Requests",
      "ja-JP": "特別なリクエスト",
      "ko-KR": "특별 요청",
      "ms-MY": "Permintaan Khas"
    },
    items: [
      {
        text: "我有花生过敏",
        translations: {
          "en-US": "I have a peanut allergy",
          "ja-JP": "ピーナッツアレルギーがあります",
          "ko-KR": "땅콩 알레르기가 있습니다",
          "ms-MY": "Saya ada alahan kacang tanah"
        }
      },
      {
        text: "不要放味精",
        translations: {
          "en-US": "No MSG please",
          "ja-JP": "MSGは使用しないでください",
          "ko-KR": "MSG를 넣지 말아주세요",
          "ms-MY": "Jangan masukkan MSG"
        }
      },
      {
        text: "我是素食者",
        translations: {
          "en-US": "I am vegetarian",
          "ja-JP": "ベジタリアンです",
          "ko-KR": "채식주의자입니다",
          "ms-MY": "Saya vegetarian"
        }
      },
      {
        text: "食材需要分开",
        translations: {
          "en-US": "Ingredients need to be separated",
          "ja-JP": "材料を分けてください",
          "ko-KR": "재료를 분리해 주세요",
          "ms-MY": "Bahan-bahan perlu diasingkan"
        }
      }
    ]
  },
  {
    category: "基本用语",
    translations: {
      "en-US": "Basic Phrases",
      "ja-JP": "基本フレーズ",
      "ko-KR": "기본 문구",
      "ms-MY": "Frasa Asas"
    },
    items: [
      {
        text: "谢谢",
        translations: {
          "en-US": "Thank you",
          "ja-JP": "ありがとうございます",
          "ko-KR": "감사합니다",
          "ms-MY": "Terima kasih"
        }
      },
      {
        text: "对不起",
        translations: {
          "en-US": "I'm sorry",
          "ja-JP": "すみません",
          "ko-KR": "죄송합니다",
          "ms-MY": "Maaf"
        }
      },
      {
        text: "请稍等",
        translations: {
          "en-US": "Please wait",
          "ja-JP": "少々お待ちください",
          "ko-KR": "잠시만 기다려주세요",
          "ms-MY": "Sila tunggu"
        }
      },
      {
        text: "好的，明白了",
        translations: {
          "en-US": "OK, understood",
          "ja-JP": "はい、分かりました",
          "ko-KR": "네, 알겠습니다",
          "ms-MY": "Baik, faham"
        }
      }
    ]
  }
]; 